import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { milesNumber } from '../../lib/ep.js';

const ChartInfo = (props) => {
	const extra = props?.extra ?? false;
	const last_update = props?.updated ?? null;

	const tz = props?.timezone ?? 'Europe/Madrid';
	const last_update_tz = EPGetTimezone(last_update, tz, 'LLL');
	const show_tz = true; //!inArray(tz,['Europe/Amsterdam','Europe/Belgrade','Europe/Brussels','Europe/Madrid']);
	const label_timezone = (show_tz) ? <span>{window?.visible_timezones?.[tz] ?? tz}</span> : '';
	const total_registers = extra?.total_registers ?? 0;
	const total_unique_registers = extra?.total_unique_registers ?? 0;
	const label_totals = (total_registers > 0 && total_unique_registers > 0) ? "Total{total}, Uniques{uniques}" : (total_registers > 0 ? "Total{total}" : null);
	
	const display_total = (label_totals && (props?.display_total ?? true)) ? true : false;
	const display_last_update = (last_update && (props?.display_last_update ?? true)) ? true : false;
	const display_info = (total_registers > 0 && (display_total || display_last_update)) ? true : false;
	if(!display_info) return null;

	const last_update_classes = ['gui_flexbox_auto', 'gui_flex_col', 'gui_flex_nowrap', 'gui_flex_end', 'gui_small_text'];
	if(label_totals) last_update_classes.push('gui_not_in_bottom_small');

	return (
		<div class="gui_flex_space_between gui_flexbox_auto">
			{(display_total) && (
				<p
					class="gui_not_in_bottom_small"
					dangerouslySetInnerHTML={{
						__html:props.intl.formatMessage({
							id:label_totals,
						}, {
							total:`: <strong>${milesNumber(total_registers)}</strong>`,
							uniques:`: <strong>${milesNumber(total_unique_registers)}</strong>`,
						})
					}}
				/>
			)}

			{(display_last_update) && (
				<div class={last_update_classes.join(" ")}>
					<FormattedMessage 
						id="Last update: {date}" 
						values={{date:`${last_update_tz}`}}
					/>

					{label_timezone}
				</div>
			)}
		</div>
	)
};

export default injectIntl(ChartInfo);